// extracted by mini-css-extract-plugin
export default {"assembly__title":"assembly_assembly__title__zzsGa"};